import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sun, Moon, Languages } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { saveLanguage } from '../../utils/storage';
import Login from './Login.jsx';
import Register from './Register.jsx';

const AuthContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const { toggleTheme, isDark } = useTheme();
  const { i18n } = useTranslation();
  
  const isLogin = location.pathname === '/login';
  const isRegister = location.pathname === '/register';

  const handleToggle = (newPath) => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    
    // Add a small delay to allow the transition to start
    setTimeout(() => {
      navigate(newPath);
      // Reset transition state after navigation
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 50);
  };

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLanguage);
    saveLanguage(newLanguage);
  };

  return (
    <>
      {/* Fixed Theme Toggle Button */}
      <button
        onClick={toggleTheme}
        className="fixed bottom-6 right-6 z-50 glass-button p-3 rounded-full"
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>

      {/* Fixed Language Toggle Button */}
      <button
        onClick={toggleLanguage}
        className="fixed bottom-20 right-6 z-50 glass-button p-3 rounded-full"
        aria-label={`Switch to ${i18n.language === 'en' ? 'Arabic' : 'English'}`}
      >
        <span className="text-sm font-medium">
          {i18n.language === 'en' ? 'AR' : 'EN'}
        </span>
      </button>

      <div className="relative">
        {/* Login Form */}
        <div 
          className={`transition-all duration-500 ease-in-out transform ${
            isLogin 
              ? 'opacity-100 translate-y-0 scale-100' 
              : 'opacity-0 translate-y-4 scale-95 pointer-events-none absolute inset-0'
          }`}
        >
          <Login onToggle={() => handleToggle('/register')} />
        </div>

        {/* Register Form */}
        <div 
          className={`transition-all duration-500 ease-in-out transform ${
            isRegister 
              ? 'opacity-100 translate-y-0 scale-100' 
              : 'opacity-0 translate-y-4 scale-95 pointer-events-none absolute inset-0'
          }`}
        >
          <Register onToggle={() => handleToggle('/login')} />
        </div>
      </div>
    </>
  );
};

export default AuthContainer;
